import React from 'react';

// Favorite Icons
export const FavoriteFilled = ({ width = 32, height = 32, color = "#E91E63", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M16 28C16 28 3 19 3 11C3 6.58172 6.58172 3 11 3C13.5 3 15.5 4 16 4.5C16.5 4 18.5 3 21 3C25.4183 3 29 6.58172 29 11C29 19 16 28 16 28Z"
      fill={color}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FavoriteOutlined = ({ width = 32, height = 32, color = "#666", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M16 28C16 28 3 19 3 11C3 6.58172 6.58172 3 11 3C13.5 3 15.5 4 16 4.5C16.5 4 18.5 3 21 3C25.4183 3 29 6.58172 29 11C29 19 16 28 16 28Z"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// People Capacity Icon
export const PeopleIcon = ({ width = 24, height = 24, color = "currentColor", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Surface Area Icon
export const SurfaceIcon = ({ width = 24, height = 24, color = "currentColor", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Tall rectangle */}
    <rect x="4.5" y="3.5" width="15" height="17" rx="1" stroke={color} strokeWidth="1.5" />
    
    {/* Double-ended measurement arrows */}
    <g stroke={color} strokeWidth="1.8" strokeLinecap="round">
      {/* Diagonal measurement line */}
      <path d="M8 7L16 15" />
      
      {/* Arrowheads - top left */}
      <path d="M8.5 6.5L7 7L8 8" fill={color} />
      <path d="M7.5 7.5L8 8L8.5 6.5" fill={color} />
      
      {/* Arrowheads - bottom right */}
      <path d="M15.5 15.5L17 15L16 14" fill={color} />
      <path d="M16.5 14.5L16 14L15.5 15.5" fill={color} />
      
      {/* Second diagonal measurement line */}
      <path d="M16 7L8 15" />
      
      {/* Arrowheads - top right */}
      <path d="M15.5 6.5L17 7L16 8" fill={color} />
      <path d="M16.5 7.5L16 8L15.5 6.5" fill={color} />
      
      {/* Arrowheads - bottom left */}
      <path d="M8.5 15.5L7 15L8 14" fill={color} />
      <path d="M7.5 14.5L8 14L8.5 15.5" fill={color} />
    </g>
  </svg>
);

// Star Icon for Reviews
export const StarIcon = ({ width = 16, height = 16, color = "#FFD700", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M8 1L10.18 5.14L14.5 5.86L11.25 9.14L12.36 13.5L8 11.14L3.64 13.5L4.75 9.14L1.5 5.86L5.82 5.14L8 1Z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>
);